import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Loading, Modal } from '@orobix/orobix-fe-components'
import { Trans, useTranslation } from 'react-i18next'

import {
  getIsExceeded,
  getQuota,
  getRemaining,
  getStatus,
  getUsed,
} from '../../../utils/counter'
import useStyles from './DownloadConfirmationModal.styles'
import { useDownloadCounterData } from './useDownloadCounterData'

export interface DownloadConfirmationModalProps {
  onCloseRequest: () => void
  onDownloadRequest: () => void
}

export const DownloadConfirmationModal = ({
  onCloseRequest,
  onDownloadRequest,
}: DownloadConfirmationModalProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { counter } = useDownloadCounterData()

  const remaining = getRemaining(counter)
  const used = getUsed(counter)
  const quota = getQuota(counter)
  const isExceeded = getIsExceeded(counter)

  const handleClick = () => {
    onCloseRequest()
    onDownloadRequest()
  }

  return (
    <Modal
      size="sm"
      onCloseRequest={onCloseRequest}
      title={t('Confirm download')}
      footer={
        counter ? (
          <>
            <Button
              onClick={onCloseRequest}
              label={t('Cancel')}
              type="default"
              buttonType="button"
            />
            <Button
              onClick={handleClick}
              icon={<FontAwesomeIcon icon={faDownload} />}
              label={t('Download')}
              type="action"
              buttonType="button"
              disabled={counter.isEnabled && isExceeded}
            />
          </>
        ) : null
      }
    >
      {
        {
          allowed: (
            <Trans
              i18nKey="You have only <emph>{{ count }} download left</emph> ({{ used }} used over {{ quota }} available). Are you sure you want to proceed?"
              values={{ count: remaining, quota, used }}
              components={{ emph: <b className={classes.emph} /> }}
            />
          ),
          forbidden: t('Sorry, you reached maximum download limit.'),
          disabled: t('Great, you have unlimited downloads.'),
          loading: <Loading />,
        }[getStatus(counter)]
      }
    </Modal>
  )
}

export default DownloadConfirmationModal
